export const handleInputKeyPressForQtyAndValueInput = (event, decimalPlacesParam) => {
    const inputValue = event.target.value
    const pressedKey = event.key
    const tmpDecimalPlaces = decimalPlacesParam ? decimalPlacesParam : 0
    const allowComma = tmpDecimalPlaces > 0

    if (pressedKey === '.' || pressedKey === ',') {
        if (tmpDecimalPlaces === 0 || inputValue.includes('.') || inputValue.includes(',')) {
            return false
        }
    }
    if (allowComma) {
        if (!/[0-9]/.test(pressedKey) && pressedKey !== "Backspace" && pressedKey !== '.' && pressedKey !== ',') {
            return false
        }
    }
    else {
        if (!/[0-9]/.test(pressedKey) && pressedKey !== "Backspace") {
            return false
        }
    }
    // if (tmpDecimalPlaces === 0) {
    //     if ((inputValue.length === 0 && pressedKey === '0') ||
    //         (inputValue === "0" && inputValue.length === 1 && pressedKey === '0')) {
    //         return false
    //     }
    // }
    if (inputValue === '0' && pressedKey === '0') {
        return false // blokuje wpisania 0 gdy 0 jest pierwsze
    }
    return true
}

export const handleOnChangeForQtyAndValueInput = (event, decimalPlacesParam, salesRatio) => {
    let value = event.target.value == '' || event.target.value.trim() == '' ? '' : event.target.value
    event.target.value = value
    const tmpDecimalPlaces = decimalPlacesParam ? decimalPlacesParam : 0
    const allowComma = tmpDecimalPlaces > 0
    let addCommaToLenght = tmpDecimalPlaces === 0 ? 0 : 1
    if (value.length >= (6 + decimalPlacesParam + addCommaToLenght)) {
        return false
    }
    let regex
    if (allowComma) {
        regex = new RegExp(`^\\d*((\\.|,)\\d{0,${tmpDecimalPlaces}})?$`)
    }
    else {
        // regex = new RegExp(`[0-9]`)
        regex = new RegExp(`^[0-9]*$`);
    }
    if (!regex.test(value)) {
        return false
    }
    return true
}

export const handleInputForQtyAndValueFocus = (event, isDevexpressComponent) => {
    if (isDevexpressComponent) {
        event.component.selectAll()
    }
    else {
        event.target.select()
    }
}

export const handleInputForQtyAndValueLostFocus = (event, decimalPlacesParam) => {
    const tmpDecimalPlaces = decimalPlacesParam ? decimalPlacesParam : 0
    event.target.value = parseFloat(event.target.value).toFixed(tmpDecimalPlaces)
}